import { afterNextRender, inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Language, SupportedLanguages } from '@common';
import { toObservable } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LanguageStore {
  language = signal<(typeof SupportedLanguages)[number]>({
    label: '한국어',
    lang: 'ko',
  });

  private translateService = inject(TranslateService);

  constructor() {
    afterNextRender(() => this.detectBrowserLanguage.bind(this));

    toObservable(this.language)
      .pipe(
        map((lang) => lang.lang),
        distinctUntilChanged(),
      )
      .subscribe((lang) => {
        this.translateService.use(lang);
        document.documentElement.setAttribute('lang', lang);
      });
  }

  setLanguage(lang: Language | string) {
    if (typeof lang === 'string') {
      const foundLanguage = SupportedLanguages.find(
        (supportedLanguage) => supportedLanguage.lang === lang,
      );
      if (foundLanguage) {
        this.language.set(foundLanguage);
        return;
      }
    } else {
      this.language.set(lang);
    }
  }

  detectBrowserLanguage() {
    const lang = navigator.language;

    for (const supportedLanguage of SupportedLanguages) {
      if (lang.startsWith(supportedLanguage.lang)) {
        this.language.set(supportedLanguage);
        return;
      }
    }

    this.language.set({
      label: '한국어',
      lang: 'ko',
    });
  }
}
